import { instance, instanceWithAuth, callApiWithSpinner } from './index'
import store from '@/store/index'

// 로그인 API
function loginUser(userData) {
  return callApiWithSpinner(() => instance.post('/mobile/login', userData))
}

function firstLoginUser(userData) {
  return callApiWithSpinner(() =>
    instance.post('/mobile/login/first', userData)
  )
}

// 로그아웃 API
// 2024-08-05 : 로그인 정책에 맞춰 uuid추가
// 2024-08-07 : delete 맵핑 오류로 인해 post로 변경
function logoutUser(m_id, uuid) {
  return instance.post('/mobile/logout', {
    m_id: m_id,
    uuid: uuid,
  })
}

// SSO 로그인을 위한 token 요청
function getSsoToken(urlInfo) {
  return instanceWithAuth.post('/mobile/token', urlInfo)
}

// 앱 시작 시 앱 버전 체크
function getAppversion(deviceOs) {
  return instance.get('/mobile/version', {
    params: {
      deviceOs: deviceOs,
    },
  })
}

// 지정된 파트만 현장 인증 신청서비스를 지원하기 위해 파트 확인
function partCheck() {
  return instanceWithAuth.get('/mobile/part')
}

// refresh토큰 확인
function refreshTokenVerify() {
  return instance.post('/mobile/token/refresh', {
    refreshToken: store.state.refreshToken,
  })
}

export {
  loginUser,
  firstLoginUser,
  logoutUser,
  getSsoToken,
  getAppversion,
  partCheck,
  refreshTokenVerify,
}
